import React from 'react'
import './Wwo.css'
import CountUpOnScroll from '../../Home/About/ScrollCounter'
import cs from '../../../../assets/img/globe.svg'
import pd from '../../../../assets/img/project_delivered.svg'
import te from '../../../../assets/img/te.svg'
import yoe from '../../../../assets/img/yoe.svg'
import cwad from '../../../../assets/img/cwad.svg'
import ecde from '../../../../assets/img/ecde.svg'
import swad from '../../../../assets/img/swad.svg'
import pwa from '../../../../assets/img/pwa.svg'
import wasm from '../../../../assets/img/wasm.svg'

function Wwo() {

  const wwolist = [
    {
      icon:cwad,
      title: "Discovery and Market Fit",
      desc: "We evaluate product range, customer segments, pricing models, and logistics to design a commerce strategy that drives revenue."
    },
    {
      icon:ecde,
      title: "UX, UI and Conversion Design",
      desc: "Our designers build product pages, checkout flows, and navigation that reduce friction and increase conversion rates."
    },
    {
      icon:swad,
      title: "Platform Development and Integrations",
      desc: "We implement catalog systems, secure payment flows, tax and shipping logic, and third-party integrations like ERPs and CRMs."
    },
    {
      icon:pwa,
      title: "Performance and Security",
      desc: "Fast page load time and secure payment handling are non-negotiable. We implement caching, CDNs, and PCI compliant payment flows."
    },
    {
      icon:wasm,
      title: "Launch, Growth and Optimization",
      desc: "Post-launch we run A/B tests, tune conversion funnels, and implement analytics to increase average order value and lifetime customer value."
    },
    
  ]

  return (
    <section className='wwo-sec'>
        <div className='container'>
            <div className='pht-sec'>
                <ul>
                    <li><img src={cs} alt='' loading="lazy"/><h4> <CountUpOnScroll end={25} />+</h4><p>Countries Served</p></li>
                    <li><img src={pd} alt='' loading="lazy"/><h4> <CountUpOnScroll end={200} />+</h4><p>Projects Delivered</p></li>
                    <li><img src={te} alt='' loading="lazy"/><h4> <CountUpOnScroll end={120} />+</h4><p>Tech Enthusiast</p></li>
                    <li><img src={yoe} alt='' loading="lazy"/><h4> <CountUpOnScroll end={10} />+</h4><p>Years of Experience</p></li>
                </ul>
            </div>
            <div className='wwo-sec1'>
            <h3>E-Commerce Development Process</h3>
              <ul>
                {
                  wwolist.map((Wwo, index)=>(
                    <li key={index}>
                      <div className='wwo-icon'><img src={Wwo.icon} alt=''/></div>
                      <h4>{Wwo.title}</h4> 
                      <p>{Wwo.desc}</p>  
                    </li>
                  ))
                }
                   
              </ul>    
            </div> 
        </div>
    </section>
  )
}

export default Wwo
